// Module
var code = "<img class=\"instructionsImage\"/> ";
// Exports
export default code;